import { CurrencyCode } from "@smartrr/shared/shopifyGraphQL/api";
import { noawait } from "@smartrr/shared/utils/noawait";
import React, { useEffect } from "react";

import { useSmartrrTheme } from "@customer-app/account/views/OperationAquarius/hooks/useSmartrrTheme";
import { useOrganization } from "@customer-app/account/views/OperationAquarius/utils";
import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

import { Loyalty } from "../..";
import { LoyaltyStoreAccess } from "../../store";
import { DeliveryAccess } from "@customer-app/state/stores/delivery";

export const LoyaltyHandler = () => {
  const actions = LoyaltyStoreAccess.useActions();
  const upcomingDelivery = DeliveryAccess.useUpcomingDelivery();
  const isLoyaltyEnabled = LoyaltyStoreAccess.useIsLoyaltyEnabled();
  const isSpecialReferralsEnabled = !!LoyaltyStoreAccess.useSpecialReferralsVariantId();
  const tieredPoints = useSmartrrCustomerSelector(state => state.auth.customerRelationship?.tieredPoints);
  const yearlyTieredPoints = useSmartrrCustomerSelector(
    state => state.auth.customerRelationship?.yearlyTieredPoints
  );
  const cumulativePoints = useSmartrrCustomerSelector(state => state.auth.customerRelationship?.orgPoints);
  const latestOrder = useSmartrrCustomerSelector(state => state.orders.latestOrder);
  const isOtpLoyaltyEnabled = LoyaltyStoreAccess.useIsOtpEnabled();

  const theme = useSmartrrTheme();
  const organization = useOrganization();

  useEffect(() => {
    noawait(async () => actions.fetchLoyalty());
  }, []);

  useEffect(() => {
    actions.points.updateCumulativePoints(cumulativePoints ?? 0);
  }, [cumulativePoints]);

  useEffect(() => {
    actions.points.updateTieredPoints(tieredPoints ?? 0);
  }, [tieredPoints]);

  useEffect(() => {
    actions.tiers.updateTier(yearlyTieredPoints);
  }, [tieredPoints, isLoyaltyEnabled]);

  useEffect(() => {
    actions.order.updateUpcoming(upcomingDelivery ?? null);
  }, [upcomingDelivery]);

  useEffect(() => {
    actions.currency.update(organization.shopifyStoreData?.currency ?? CurrencyCode.Usd);
  }, [organization.shopifyStoreData]);

  useEffect(() => {
    actions.order.updatePurchased(latestOrder);
  }, [latestOrder]);

  const considerOTP = isOtpLoyaltyEnabled ?? false;
  const considerSubscription = !!upcomingDelivery;

  const showLoyalty =
    theme.modernThemeSettings?.sections.rewards.display &&
    (isLoyaltyEnabled || isSpecialReferralsEnabled) &&
    (considerOTP || considerSubscription);

  return showLoyalty ? <Loyalty /> : null;
};
